import { useDeviceStorage } from '../adapters/ports.js';

// Local persistence for the Live tab's attended sale + recent sales, through
// the host's device-storage port. There is no backend for it: which sale a
// dealer is standing in is a fact about this device, and a second device
// signed in as the same dealer is legitimately somewhere else.
//
// Bump this suffix when the persisted shape changes so a stale value is
// discarded rather than mis-applied on the boot path.
const ATTEND_KEY = 'aac.attend.v1';

// Keep the recents row short — it's a quick-switch aid, not a history.
export const RECENTS_MAX = 6;

const EMPTY = { selectedSale: null, recentSales: [] };

// Never rejects, and never returns a half-shape: the port answers null for both
// a missing value and a malformed one, and the field-by-field read below turns
// anything else unexpected into the empty selection. The Live tab can then
// hydrate and auto-select a sale rather than failing on the boot path.
export async function getAttendance() {
  const parsed = await useDeviceStorage().getJson(ATTEND_KEY);
  if (!parsed) return { ...EMPTY };
  const selectedSale = typeof parsed.selectedSale === 'string' ? parsed.selectedSale : null;
  const recentSales = Array.isArray(parsed.recentSales)
    ? parsed.recentSales.filter((sale) => typeof sale === 'string').slice(0, RECENTS_MAX)
    : [];
  return { selectedSale, recentSales };
}

export async function setAttendance(value) {
  await useDeviceStorage().setJson(ATTEND_KEY, {
    selectedSale: value.selectedSale ?? null,
    recentSales: (value.recentSales ?? []).slice(0, RECENTS_MAX)
  });
}

export async function clearAttendance() {
  await useDeviceStorage().remove(ATTEND_KEY);
}

export const saleSelectionStorage = { getAttendance, setAttendance, clearAttendance, RECENTS_MAX };
export default saleSelectionStorage;
